import { colors } from 'src/components/app-ui'

const PHONE = '@media (max-width: 479.98px)'

// Shared by the Courses and Learning paths list pages.
const styles = () => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    // Phone: search on its own full-width row, filters and sort below it.
    [PHONE]: {
      '& > label:first-child': {
        width: '100%',
      },
    },
  },
  filters: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '20px',
    [PHONE]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  filterButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    color: colors.navy,
  },
  noResults: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    padding: '48px 24px',
    textAlign: 'center',
    '& img': {
      maxWidth: 200,
      marginBottom: 8,
    },
  },
  noResultsTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: colors.navy,
  },
  noResultsText: {
    marginBottom: 8,
    fontSize: '14px',
    color: colors.muted,
  },
  empty: {
    padding: '48px 24px',
    border: `1px dashed ${colors.border}`,
    borderRadius: '12px',
    textAlign: 'center',
    fontSize: '14px',
    color: colors.muted,
  },
})

export default styles
